import { render, staticRenderFns } from "./ServicesPredict.vue?vue&type=template&id=47234c70&scoped=true&"
import script from "./ServicesPredict.vue?vue&type=script&lang=js&"
export * from "./ServicesPredict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47234c70",
  null
  
)

export default component.exports